export default "<app-login style=\"background-color:#5CC5BA;\" *ngIf=\"!login\"></app-login>\r\n<app-navigation *ngIf=\"login\"></app-navigation>\r\n"